module.exports = __webpack_public_path__ + "static/media/home-easily-track-student-positivity.eb8842ed.png";